import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllWarrantiesResponse, IWarranty } from "../models/Warranty";

export default function useWarranties() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const warranties = useQuery({
    queryKey: ["warranties"],
    queryFn: () => get<IAllWarrantiesResponse>("/warranty"),
    refetchInterval: 1000 * 10,
  });

  const create = useMutation(
    (warranty: IWarranty) => post("/warranty", warranty),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["warranties"]);
      },
    }
  );

  const update = useMutation(
    (warranty: IWarranty) => put(`/warranty/${warranty.id}`, warranty),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["warranties"]);
      },
    }
  );

  const remove = useMutation(
    (warrantyId: string) => del(`/warranty/${warrantyId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["warranties"]);
      },
    }
  );

  return {
    warranties,
    create,
    update,
    remove,
  };
}
